module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chevron-up.svg?7a6b688cdad4695e81ad82a91bbdb5ea";